import React from "react";
import { useHistory } from "react-router-dom";

import {
  classDataPath,
  videoLessonPath,
  prefixPath,
} from "../../../../teacherStore";
import { ITeachingMaterial, ILesson } from "../../../../state";
import { ReactComponent as PicoIcon } from "../../../../assets/svg/pico_counseling.svg";
import OrientationAllPdf from "../../../../assets/pdf/orientation_all.pdf";
import OrientationGuidelinePdf from "../../../../assets/pdf/orientation_guideline.pdf";
import OrientationCorePdf from "../../../../assets/pdf/orientation_core.pdf";
import OrientationAllImage from "../../../../assets/images/orientation_ALL.png";
import OrientationCoreImage from "../../../../assets/images/orientation_CORE.png";
import OrientationVideoAllImage from "../../../../assets/images/orientation_video_ALL.png";
import OrientationVideoCoreImage from "../../../../assets/images/orientation_video_CORE.png";
import { isOldMaterial } from "../../../../libs/teachingMaterialUtils";
import styles from "../SelectPage.module.scss";

import ActionColumn from "./ActionColumn";
import ActionCard from "./ActionCard";

interface ILessonActionGridProps {
  activeMaterial: ITeachingMaterial;
  activeLesson: ILesson;
  isCurrentOrientation: boolean;
  isIntroLesson: boolean;
  isBlankNameLesson: boolean;
  isBaseCategory: boolean;
  targetClassIds: number[];
  classList: string[];
  has_g4s_order: boolean;
  has_g4s_basic_order: boolean;
  extra: string;
  onOpenVideo: () => void;
  onOpenGuideline: (teaching_material_id: number, lesson_id: number) => void;
  onOpenMaterial: (teaching_material_id: number, lesson_id: number) => void;
  onOpenSubPage: (teaching_material_id: number, lesson_id: number) => void;
  onExecuteLessonAction: (lesson: ILesson, actionCallback: () => void) => void;
  onShowChat: () => void;
}

const LessonActionGrid = ({
  activeMaterial,
  activeLesson,
  isCurrentOrientation,
  isIntroLesson,
  isBlankNameLesson,
  isBaseCategory,
  targetClassIds,
  classList,
  has_g4s_order,
  has_g4s_basic_order,
  extra,
  onOpenVideo,
  onOpenGuideline,
  onOpenMaterial,
  onOpenSubPage,
  onExecuteLessonAction,
  onShowChat,
}: ILessonActionGridProps) => {
  const history = useHistory();

  const oldMaterial = isOldMaterial(activeMaterial.mitsuwa_id);

  return (
    <div className={styles.threeColumnGrid}>
      {isCurrentOrientation ? (
        <>
          <ActionColumn
            stepNum="01"
            headerText="授業の準備をする"
            columnSub="準備方法を1つ選んでください"
          >
            <ActionCard
              href={OrientationGuidelinePdf}
              title="指導書"
              time="20分"
              pinText="しっかり準備"
            />
          </ActionColumn>
          <ActionColumn
            stepNum="02"
            headerText="授業をする"
            columnSub="投影する教材を1つ選んでください"
          >
            <ActionCard
              href={
                !has_g4s_order && !has_g4s_basic_order
                  ? OrientationCorePdf
                  : OrientationAllPdf
              }
              title="スライドで進行"
              pinText="先生のペースで、対話を中心に進められる"
              thumbnailUrl={
                !has_g4s_order && !has_g4s_basic_order
                  ? OrientationCoreImage
                  : OrientationAllImage
              }
              isMaterialCard={true}
            />
            <ActionCard
              onClick={onOpenVideo}
              title="ナビ動画で進行"
              pinText="動画に沿って進行し、ワーク支援に集中できる"
              thumbnailUrl={
                !has_g4s_order && !has_g4s_basic_order
                  ? OrientationVideoCoreImage
                  : OrientationVideoAllImage
              }
              showComingSoon={false}
              isMaterialCard={true}
            />
          </ActionColumn>
          <ActionColumn isEmpty stepNum="" headerText="" columnSub="" />
        </>
      ) : isIntroLesson ? (
        <>
          <ActionColumn
            stepNum="01"
            headerText="授業の準備をする"
            columnSub="準備方法を1つ選んでください"
          >
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenGuideline(activeMaterial.id, activeLesson.id),
                )
              }
              title="指導書"
              time="3分"
              pinText="しっかり準備"
            />
          </ActionColumn>
          <ActionColumn isEmpty stepNum="" headerText="" columnSub="" />
          <ActionColumn isEmpty stepNum="" headerText="" columnSub="" />
        </>
      ) : isBlankNameLesson || isBaseCategory ? (
        <>
          <ActionColumn
            stepNum="01"
            headerText="授業の準備をする"
            columnSub="準備方法を1つ選んでください"
          >
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenGuideline(activeMaterial.id, activeLesson.id),
                )
              }
              title="指導書"
              time={isBlankNameLesson ? "5分" : "20分"}
              pinText="しっかり準備"
            />
          </ActionColumn>
          <ActionColumn
            stepNum="02"
            headerText="授業をする"
            columnSub="投影する教材を1つ選んでください"
          >
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenMaterial(activeMaterial.id, activeLesson.id),
                )
              }
              title="スライドで進行"
              pinText="先生のペースで、対話を中心に進められる"
              thumbnailUrl={activeLesson.image_url}
              isMaterialCard={true}
            />
          </ActionColumn>
          <ActionColumn
            stepNum="03"
            headerText="振り返る"
            columnSub="振り返り方法を1つ選んでください"
          >
            <ActionCard
              onClick={() => {
                if (targetClassIds.length > 0 && targetClassIds[0]) {
                  history.push(`${classDataPath}/${targetClassIds[0]}`, {
                    nameClass: classList[0],
                  });
                }
              }}
              title="生徒個別データ"
              pinText="生徒ごとに振り返る"
            />
          </ActionColumn>
        </>
      ) : (
        <>
          <ActionColumn
            stepNum="01"
            headerText="授業の準備をする"
            columnSub="準備方法を1つ選んでください"
          >
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenGuideline(activeMaterial.id, activeLesson.id),
                )
              }
              title="指導書"
              time="20分"
              pinText="しっかり準備"
            />
            {activeLesson.preparation_image_url && (
              <ActionCard
                onClick={() =>
                  onExecuteLessonAction(activeLesson, () =>
                    window.open(activeLesson.preparation_image_url, "_blank"),
                  )
                }
                title="ダイジェスト指導書"
                time="10分"
                pinText="時短で準備"
              />
            )}
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenSubPage(activeMaterial.id, activeLesson.id),
                )
              }
              title="補助スライド"
              time="5分"
              pinText="台本で準備"
            />

            {!oldMaterial && (
              <div
                className={styles.picoIconWrapper}
                onClick={() => onShowChat()}
              >
                <PicoIcon />
              </div>
            )}
          </ActionColumn>
          <ActionColumn
            stepNum="02"
            headerText="授業をする"
            columnSub="投影する教材を1つ選んでください"
          >
            <ActionCard
              onClick={() =>
                onExecuteLessonAction(activeLesson, () =>
                  onOpenMaterial(activeMaterial.id, activeLesson.id),
                )
              }
              title="スライドで進行"
              pinText="先生のペースで、対話を中心に進められる"
              thumbnailUrl={activeLesson.image_url}
              isMaterialCard={true}
            />
            {!oldMaterial && (
              <ActionCard
                onClick={() => {
                  if (activeLesson.first_video_chapter_id) {
                    onExecuteLessonAction(activeLesson, () => {
                      window.open(
                        `${prefixPath}${videoLessonPath}?lesson=${
                          activeLesson.id
                        }&chapter=${
                          activeLesson.first_video_chapter_id
                        }&classList=${targetClassIds.join(",")}`,
                        "_blank",
                      );
                    });
                  }
                }}
                title="ナビ動画で進行"
                pinText="動画に沿って進行し、ワーク支援に集中できる"
                thumbnailUrl={activeLesson.video_chapter_image_url}
                showComingSoon={!activeLesson.first_video_chapter_id}
                disabled={!activeLesson.first_video_chapter_id}
                isMaterialCard={true}
              >
                {!activeLesson.first_video_chapter_id &&
                  activeLesson.support_video_url && (
                    <a
                      className={styles.supportVideoLink}
                      href={`${
                        process.env.REACT_APP_ONE_MENU_URL
                      }/contents/support_tools?link=support_video&lesson=${
                        activeLesson.id
                      }&classList=${targetClassIds.join(",")}${extra}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => e.stopPropagation()}
                    >
                      授業サポート動画はこちら
                    </a>
                  )}
              </ActionCard>
            )}
          </ActionColumn>
          <ActionColumn
            stepNum="03"
            headerText="振り返る"
            columnSub="振り返り方法を1つ選んでください"
          >
            <ActionCard
              onClick={() => {
                if (targetClassIds.length > 0 && targetClassIds[0]) {
                  window.open(
                    `${process.env.REACT_APP_ONE_MENU_URL}/class_retrospect/${targetClassIds[0]}?teaching_material_id=${activeMaterial.id}&lesson_id=${activeLesson.id}${extra}`,
                    "_blank",
                  );
                }
              }}
              title="授業毎データ"
              pinText="Lessonごとに振り返る"
            />
            <ActionCard
              onClick={() => {
                if (targetClassIds.length > 0 && targetClassIds[0]) {
                  history.push(`${classDataPath}/${targetClassIds[0]}`, {
                    nameClass: classList[0],
                  });
                }
              }}
              title="生徒個別データ"
              pinText="生徒ごとに振り返る"
            />
          </ActionColumn>
        </>
      )}
    </div>
  );
};

export default LessonActionGrid;
